__turbopack_context__.v({
  "checkboxSmall": "n4kaaq_checkboxSmall",
  "disclaimerContainer": "n4kaaq_disclaimerContainer",
  "disclaimerContent": "n4kaaq_disclaimerContent",
  "disclaimerText": "n4kaaq_disclaimerText",
  "inputError": "n4kaaq_inputError",
  "privacyStatementLink": "n4kaaq_privacyStatementLink",
});
